<style scoped>

</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'top':'20%','min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem :label="$t('deviceManage.manageModel.titleName.ProductName')" prop="productId"  style="width: 500px">
                <SearchSelect ref="pageId" :url="pagesIdListUrl" listName="productList"  :selectUrlQuery="{page:1,limit:10000}" labelName='productType' isMultiple='2'  valName='id' keyword="productType" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'productId')"></SearchSelect>
            </FormItem>

            <FormItem  v-show='formData.baseType' :label="$t('deviceManage.baseType')" prop="baseType"  style="width: 500px">
                 <Input  type="text" :value="formData.baseType" disabled></Input>
            </FormItem>

            <FormItem :label="$t('deviceManage.manageModel.sname')" prop="groupName"  style="width: 500px">
                 <Input type="text" v-model.trim="formData.groupName" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('deviceManage.manageModel.remark')" prop="remark"  style="width: 500px">
                 <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框--管理组织新增编辑
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../../common/selectList.vue';
import { mapState } from 'vuex'

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            editFormData:Object,
            type:Number
        },
        name: "SModel3",
        components: {
            SearchSelect
        },
        data() {
            return {   
                pagesIdListUrl:this.config.urlArray.productsManageList,//经销商产品列表里面的id字段
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    groupName: '',
                    remark:'',
                    baseType:'',
                    productId:''
                },
               
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            },
        },
        computed:{
          ...mapState(['local','selectId']),
            ruleCustom(){
                return {//验证
                    groupName: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    productId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    remark: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ]
                }
            } 

        },
        created(){
        },
        methods: {
            setSelectVal(e,key){//
            // console.log(e)
                this.formData[key] = e.nameVal+''
                this.formData.baseType = e.selItem.baseType
            },
            openOrClose(value) {
                if(value === true) {    
                    this.title =this.type==1 ? this.$t('deviceManage.manageModel.stitle') : this.$t('deviceManage.manageModel.stitle1')

                    if(this.type==2){
                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }
                        this.formData.productId = this.editFormData.productId+''
                        
                        this.$nextTick(()=>{//select赋值
                           this.$refs.pageId.setDefVal(Number(this.formData.productId));
                           
                        });
                    }else{
                        this.$nextTick(()=>{//select赋值
                             this.$refs.pageId.setQuery(null)
                        });
                    }
                     
                } else { //关闭弹框后要做的处理
                    this.$refs.pageId.clearVal();
                    this.fn()
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                       
                        this.disabled = true      
                        let url = ''
                        let params = {}
                        if(this.type==1){
                            url=this.config.urlArray.deviceGroupsAdd
                            params = {...this.formData,dealerId:this.selectId}
                        }else{
                            url=this.config.urlArray.deviceGroupsSet
                            params = {...this.formData,dealerId:this.selectId,id:this.editFormData.id}
                        }
                        //  console.log('this.formData',this.formData,url)
                        
                        this.axios.post(url, params).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })
                            
                        }).catch((err) => {
                            this.disabled = false;
                            // common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.fn()
                this.resetForm()
                this.$emit('update:showModel',false);

            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
            }
        }
    }
</script>
